// extracted by mini-css-extract-plugin
export default {"icons":"input_field_icons-module___icons___a94410f1"};